<template>

  <svg class="svg-node"><!-- 五边形 -->
    <g transform="translate(0.5,0.5)" style="visibility: visible">
      <polygon
        points="5.32,0 22.68,0 28,28 0,28"
        fill="#ffffff"
        stroke="#000000"
        stroke-width="1.3"
        pointer-events="all"
      ></polygon>
    </g>
  </svg>
</template>

<script>
export default {
}
</script>